import React from 'react'

const ManageAssignment = () => {
  return (
    <div>ManageAssignment</div>
  )
}

export default ManageAssignment;